import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import type { NoteTypes } from "db/types";
import { apiRequest, ApiError } from "@/lib/http";

/**
 * Server function to fetch all notes for the authenticated user.
 * Forwards incoming request cookies for API authentication.
 */
export const getNotes = createServerFn({ method: "GET" }).handler(async () => {
  try {
    const request = getRequest();
    return await apiRequest<NoteTypes.SerializedNote[]>("/api/notes", {
      request,
    });
  } catch (error) {
    if (ApiError.isUnauthorized(error) || ApiError.isForbidden(error)) {
      return [];
    }
    console.error("[getNotes] Failed to fetch notes:", error);
    return [];
  }
});
